import "./App.css"
import { useState } from "react"
const AddTask = ({ taskList, setTaskList }) => {
    const [state, setState] = useState(false);
    const [taskName, setTaskName] = useState("");
    const [taskDiscription, setTaskDiscription] = useState("");

    const handleAdd = (e) => {
        e.preventDefault()
        if (!taskName) {
            alert("enter the Task Name to continue")
        }
        else {
            let tempList = taskList;
            tempList.push({ taskName, taskDiscription })
            setState(false);
            // setTaskList([...taskList, { taskName, taskDiscription }]);
            setTaskName("");
            setTaskDiscription("");
            localStorage.setItem("taskList", JSON.stringify(tempList))
            window.location.reload();
        }

    }
    const handleInput = e => {
        const { name, value } = e.target;
        if (name === "taskName") setTaskName(value);
        if (name === "taskDiscription") setTaskDiscription(value)
    }

    return (
        <div className="FirstPage">
            <p>You can add multiple task here!!</p><button onClick={() => { setState(true) }}>Add task+</button>
            {state ? (
                <div className="Addtask bg-dark w-50  h-100 position-fixed  p-4  border-0 ">
                    <div className="heading text-white  border-bottom "> <h2>Add new Task :</h2>
                        <button className="CloseButton p-2" onClick={() => { setState(false) }}>X</button></div >
                    <label className=" text-white  fs-1 " htmlFor="task-name">Task Name :</label>
                    <input className=" fs-3  p-1 " placeholder="" name="taskName" required value={taskName} onChange={handleInput} />
                    <label className=" text-white  fs-2 " htmlFor="task-discription  ">Task Discription :</label>
                    <textarea className=" border-0 fs-3  p-2 " name="taskDiscription" required value={taskDiscription} onChange={handleInput} />
                    <button className="AddButton" onClick={handleAdd}>Add</button>
                </div>
            ) : null}

        </div>
    )
}
export default AddTask;